import React, { useEffect, useState } from 'react';
/** Local elapsed-time timer; never claims to notify when the browser is closed. */
export default function KitchenTimer() {
  const [minutes, setMinutes] = useState('5');
  const [deadline, setDeadline] = useState<number | null>(null);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!deadline) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [deadline]);
  const seconds = deadline ? Math.max(0, Math.ceil((deadline - now) / 1000)) : 0;
  return <details className="cs-cooking-controls"><summary>Kitchen timer</summary>
    <p>Keep this page open. The timer does not send background notifications.</p>
    {deadline ? <><p role={seconds === 0 ? 'status' : undefined}>{seconds === 0 ? 'Timer finished — check your recipe.' : `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')} remaining`}</p><button onClick={() => setDeadline(null)}>Reset timer</button></> : <div className="cs-actions"><label>Minutes <input type="number" inputMode="numeric" min="1" max="240" value={minutes} onChange={e => setMinutes(e.target.value)} /></label><button disabled={!Number(minutes) || Number(minutes) < 1 || Number(minutes) > 240} onClick={() => { const start = Date.now(); setNow(start); setDeadline(start + Number(minutes) * 60000); }}>Start timer</button></div>}
  </details>;
}
